import axios from "axios";
import { useAuth } from "@clerk/react";
import { useMemo, useRef } from "react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fileUrl = (path) => (path && path.startsWith("/api") ? `${BACKEND_URL}${path}` : path);

export function useApi() {
  const { getToken } = useAuth();
  const tokenRef = useRef(getToken);
  tokenRef.current = getToken;
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (cfg) => {
      const t = await tokenRef.current();
      if (t) cfg.headers.Authorization = `Bearer ${t}`;
      return cfg;
    });
    return inst;
  }, []);
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0] || ""}: ${x.msg}`).join("; ");
  return d || e?.message || "Something went wrong";
};

export const money = (amount, currency) => {
  if (!amount) return "Free";
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency, maximumFractionDigits: 0 }).format(amount);
  } catch {
    return `${currency} ${amount}`;
  }
};

export const FORMAT_LABELS = {
  text: "Article", video: "Video", resource: "Download", quiz: "Quiz",
  project: "Project", live: "Live session", discussion: "Discussion",
};

export const SITUATION_LABELS = {
  job_seeker: "Job seeker", unemployed_professional: "Unemployed professional",
  recent_graduate: "Recent graduate", career_changer: "Career changer",
};
